// Styles
import "vuetify/styles";

import { createVuetify } from "vuetify";

const InstallVuetify = (app) => {
  const Vuetify = createVuetify({
    theme: {
      themes: {
        light: {
          dark: false,
          colors: {
            primary: "#2b3481",
            secondary: "#67778f",
            accent: "#5ea047",
            error: "#bf0e2e",
            info: "#1b8fe4",
            success: "#5ea047",
            warning: "#DD6363",
            links: "#1b8fe4",
          },
        },
      },
    },
    icons: {
      values: {
        custom: {
          component: () => import("@/components/icons/CheckboxIcon"),
        },
        customChecked: {
          component: () => import("@/components/icons/CheckboxIconChecked"),
        },
      },
    },
  });
  app.use(Vuetify);
};

export default InstallVuetify;
